export default function parseNetworkError(error) {
  const { parse, stringify } = JSON;
  return parse(stringify(error));
}
